// extracted by mini-css-extract-plugin
export var messageSideLeft = "_lj-1";
export var messageSideRight = "_lj-2";
export var subscribeToBackInStockBubbleContainer = "_lj-0";